import React, { ReactNode } from 'react';

import {
	author as authorStyle,
	authorDetail as authorDetailStyle,
	authorImage as authorImageStyle,
	authorName as authorNameStyle,
	authorTitle as authorTitleStyle,
	container as containerStyle,
	quote as quoteStyle,
	quoteMark as quoteMarkStyle,
} from './style.module.css';

export interface QuoteProps {
	quote: string;
	author?: string;
	authorTitle?: string;
	renderAuthorImage?(): ReactNode;
}

export const Quote = ({
	quote,
	author,
	authorTitle,
	renderAuthorImage = () => <></>,
}: QuoteProps): JSX.Element => {
	return (
		<div className={containerStyle}>
			<div className={quoteMarkStyle}>“</div>
			<div className={quoteStyle}>{quote.replace(/“|”|"/g, '')}</div>
			{(!!author || !!authorTitle) && (
				<div className={authorStyle}>
					<div className={authorImageStyle}>{renderAuthorImage()}</div>
					<div>
						{!!author && <div className={authorNameStyle}>{author}</div>}
						{!!authorTitle && <div className={authorTitleStyle}>{authorTitle}</div>}
					</div>
				</div>
			)}
		</div>
	);
};
